/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'location': {
    width: 10,
    height: 12,
    viewBox: '0 0 10 12',
    data: '<g fill-rule="nonzero" _stroke="#376F99" stroke-width=".75" _fill="none"><path pid="0" d="M4.927.375A4.551 4.551 0 0 0 .475 5.871c.076.356.175.685.3.987C1.36 8.29 2.63 9.764 4.592 11.27a.625.625 0 0 0 .728.024c1.788-1.198 3.038-2.676 3.76-4.436.061-.152.119-.306.171-.461A4.564 4.564 0 0 0 4.927.375z"/><circle pid="1" cx="4.927" cy="4.5" r="1.5"/></g>'
  }
})
